anime({
  targets: '#cloud_1-lg',
  translateX: [-600, 500],
  opacity: [0, 100],
  duration: 30000,
  easing: 'linear',
  loop: true,
  });
  anime({
    targets: '#cloud_2-lg',
    translateX: [600, -200],
    opacity: [100, 0],
    duration: 30000,
    easing: 'linear',
    loop: true,
  });
  anime({
    targets: '#sun',
    fill: ['#f4d632', '#fee769'],
    translateY: [0, -5],
    duration: 2000,
    direction: 'alternate',
    easing: 'linear',
    loop: true,
  });
  anime({
    targets: '.nutriBuilding',
    opacity: [0.4, 1],
    delay: 10000,
    duration: 5000,
    direction: 'alternate',
    easing: 'linear',
    loop: true,
  });
  anime({
    targets: '#nutriBuildingLogo',
    opacity: [0.3, 1],
    duration: 1000,
    direction: 'alternate',
    easing: 'linear',
    loop: true,
  });
  anime({
    targets: '#birds',
    translateY: [
      { value: -5 },
      { value: -8 },
      { value: 5, duration: 2000 },
      { value: 0 },
    ],
    translateX: [
      { value: 3 },
      { value: 6 },
      { value: 10, duration: 2000 },
      { value: 0 },
    ],
    duration: 8000,
    easing: 'linear',
    loop: true,
  });
  anime({
    targets: '.tree',
    skew: 1.5,
    translateX: -9,
    duration: 2000,
    easing: 'linear',
    direction: 'alternate',
    loop: true,
  });
  anime({
      targets: '#treeShadow',
      translateX: -4.7,
      duration: 2000,
      easing: 'linear',
      direction: 'alternate',
      loop: true,
  });
  anime({
    targets: '.leaf-lg-left',
    skew: 3,
    translateX: -29,
    duration: 1500,
    easing: 'linear',
    direction: 'alternate',
    loop: true,
  });
  anime({
    targets: '.leaf-md-left',
    skew: -3,
    translateX: 29,
    duration: 2000,
    easing: 'linear',
    direction: 'alternate',
    loop: true,
  });
  anime({
    targets: '.leaf-sm-left',
    skew: 3,
    translateX: -29,
    duration: 1000,
    easing: 'linear',
    direction: 'alternate',
    loop: true,
  });
  anime({
    targets: '.leaf-lg-right',
    skew: -3,
    translateX: 29,
    duration: 1500,
    easing: 'linear',
    direction: 'alternate',
    loop: true,
  });
  anime({
    targets: '.leaf-md-right',
    skew: 3,
    translateX: -29,
    duration: 2000,
    easing: 'linear',
    direction: 'alternate',
    loop: true,
  });
  anime({
    targets: '.leaf-sm-right',
    skew: -3,
    translateX: 29,
    duration: 1000,
    easing: 'linear',
    direction: 'alternate',
    loop: true,
  });
  anime({
    targets: '.football',
    translateY: -10,
    duration: 500,
    direction: 'alternate',
    easing: 'easeOutQuad',
    loop: true,
  });
  anime({
    targets: '#footballShadow',
    translateX: -10,
    translateY: 10,
    duration: 500,
    direction: 'alternate',
    easing: 'easeOutQuad',
    loop: true,
  });
  anime({
    targets: '.grassClrd',
    translateX: [0.5, -0.5],
    duration: 1000,
    delay: anime.stagger(100),
    direction: 'alternate',
    easing: 'linear',
    loop: true,
  });
  anime({
    targets: '.grassClrdGreen',
    translateX: [-0.2, 0.2],
    skew: [0.1, -0.1],
    duration: 2000,
    delay: anime.stagger(200),
    direction: 'alternate',
    easing: 'linear',
    loop: true,
  });
  anime({
    targets: '#billBoard',
    fill: ['#0d7fab','#ffffff'],
    duration: 5000,
    direction: 'alternate',
    easing: 'easeInOutQuad',
    loop: true,
  });
  anime({
    targets: '.leafScatter',
    translateX: [180, -200],
    translateY: anime.stagger([300, 0]),
    duration: 10000,
    keyframes: [
      {opacity: 1, duration: 1500},
      {opacity: 0, delay:7000 ,duration: 1500},
    ],
    easing: 'linear',
    loop: true,
  });